import React, {useEffect, useState, useRef} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import firstLogoSapore from '../media/logos/logo-sapore.png'
import secondLogoSapore from '../media/logos/id-sdp.png'
import {
    CART_PATH,
    CHECKING_ACCOUNT_PATH,
    HOME_PATH,
    LOGIN_PATH,
    ORDERS_HISTORY_PATH,
    SEARCH_PATH,
    TICKETS_PATH,
} from "../routes";
import CustomerSelector from "./CustomerSelector";

import {useApplication} from "../ApplicationProvider";
import {observer} from "mobx-react";
import {AICartButton} from "./AICartButton";
import {AICartModals} from "./AICartModals";

const Navbar = () => {
    const application = useApplication();
    const navigator = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [searchBoxActive, setSearchBoxActive] = useState(false);
    const [isMenuOpened, setMenuOpen] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(application.getCustomer());
    const [promptModalOpen, setPromptModalOpen] = useState(false);
    const [promptText, setPromptText] = useState('');
    const [isSubmittingPrompt, setIsSubmittingPrompt] = useState(false);
    const menuRef = useRef(null);
    const showAIButton = false;

    const handleOpenPromptModal = () => {
        setPromptModalOpen(true);
    };


    const handleSearchInputChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const closeSearchBox = () => {
        setSearchBoxActive(false);
    }

    const handleSearch = (e) => {
        const isEnterButton = e.keyCode === 13;
        if (isEnterButton && searchQuery !== '') {
            navigator(SEARCH_PATH + `/${searchQuery}`)
            closeSearchBox();
        }
    };

    const handleSearchButtonClick = () => {
        if (searchQuery !== '') {
            navigator(SEARCH_PATH + `/${searchQuery}`)
            closeSearchBox();
        }
    };

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                closeSearchBox();
            }
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, []);

    const model = {
        CantidadArticulos: application.order ? application.order.articles.reduce((sum, article) => sum + (article.amount || 0), 0) : 0,
        GruposTag: [],
        PedidoInicial: {
            Articulos: []
        }
    }

    const location = useLocation();

    const onMenuOpen = (event) => {
        event.preventDefault()
        setMenuOpen(!isMenuOpened)
    }

    const handleMenuClose = () => {
        setMenuOpen(false)
    }

    const handleMenuNavigate = (path) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleMenuClose();
        navigator(path);
    }

    useEffect(() => {
        handleMenuClose();
    }, [location.pathname]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && isMenuOpened) {
                setMenuOpen(false);
            }
        };

        if (isMenuOpened) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpened]);

    const menuClassName = isMenuOpened ? "dropdown open" : "dropdown"

    const handleLogout = async () => {
        const sessionIsActive = await application.session().logOut()
        if (!sessionIsActive) {
            navigator(LOGIN_PATH)
        }
    }

    const business = application.business();
    const userRoles = application.session().user().roles;
    const customers = application.session().customers()

    const handleSelect = (businessName) => {
        const newCustomer = customers.find(customer => customer.businessName === businessName);
        if (newCustomer) {
            application.setCustomer(newCustomer);
            setSelectedCustomer(newCustomer);
            application.removeOrder()
            window.location.reload()
        }
    };


    return (
        <>
            <nav className="navbar navbar-default navbar-static-top hidden-xs" style={{position: "relative", overflow: "visible"}}>
                <div className="container" style={{
                    position: "relative", 
                    paddingLeft: "15px", 
                    paddingRight: "15px",
                    display: "grid",
                    gridTemplateColumns: "auto minmax(200px, 1fr) auto",
                    alignItems: "center",
                    gap: "20px",
                    minHeight: "80px",
                    alignContent: "center"
                }}>
                    <div className="navbar-header" style={{
                        position: "relative", 
                        zIndex: 2, 
                        justifySelf: "start", 
                        gridColumn: "1",
                        display: "flex",
                        alignItems: "center",
                        height: "100%"
                    }}>
                        <ul className="list-unstyled navbar-nav" style={{display: "flex", alignItems: "center", margin: 0, padding: 0}}>
                            <li className={menuClassName} style={{display: "flex", alignItems: "center"}} ref={menuRef}>
                                <Link to={HOME_PATH} className="navbar-brand dropdown-toggle" data-toggle="dropdown"
                                      role="button" aria-expanded="false" onClick={(e) => onMenuOpen(e)}
                                      style={{display: "flex", alignItems: "center", padding: "0"}}>
                                  <span style={{display: "flex", flexDirection: "column", alignItems: "flex-start", marginRight: "8px"}}>
                                    <span className="icon-bar-nav"></span>
                                    <span className="icon-bar-nav"></span>
                                    <span className="icon-bar-nav"></span>
                                  </span>
                                    &nbsp;<span className="hidden-sm"
                                                style={{fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold', display: "flex", alignItems: "center"}}>Menú Principal</span>
                                </Link>
                                <ul className="dropdown-menu" role="menu">
                                    <li>
                                        <Link to={HOME_PATH} onMouseDown={handleMenuNavigate(HOME_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    home
                                                </span>
                                            Inicio
                                        </Link>
                                    </li>

                                    {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                        userRoles.includes(business.marketplace_operational_role())) && (
                                        <li>
                                            <Link to={CART_PATH} onMouseDown={handleMenuNavigate(CART_PATH)}>
                                                <span
                                                    className="material-symbols-sharp"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 150, 'GRAD' 50, 'opsz' 20",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    shopping_cart
                                                </span>
                                                Mi Carrito
                                            </Link>
                                        </li>
                                    )}

                                    {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                        userRoles.includes(business.marketplace_operational_role())) && (
                                        <li>
                                            <Link to={ORDERS_HISTORY_PATH} onMouseDown={handleMenuNavigate(ORDERS_HISTORY_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    local_mall
                                                </span>
                                                Mis Pedidos
                                            </Link>
                                        </li>
                                    )}

                                    {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                        userRoles.includes(business.marketplace_administrative_role())) && (
                                        <li>
                                            <Link to={CHECKING_ACCOUNT_PATH} onMouseDown={handleMenuNavigate(CHECKING_ACCOUNT_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    payments
                                                </span>
                                                Cuenta Corriente
                                            </Link>
                                        </li>
                                    )}

                                    <li>
                                        <Link to={TICKETS_PATH} onMouseDown={handleMenuNavigate(TICKETS_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    ink_pen
                                                </span>
                                            Solicitudes
                                        </Link>
                                    </li>

                                    {/*<li>*/}
                                    {/*    <Link to={PROFILE_PATH}>*/}
                                    {/*        <FontAwesomeIcon icon={faUser} className="fa-icon" /> Configuración*/}
                                    {/*    </Link>*/}
                                    {/*</li>*/}

                                    <li>
                                        <Link to={LOGIN_PATH} onMouseDown={async (event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            await handleLogout();
                                            handleMenuClose();
                                        }}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    cancel
                                                </span>
                                            Salir del Sistema
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    {/*<div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">*/}
                    {/*    {model.CantidadArticulos > 15 && (*/}
                    {/*        <ul className={`nav navbar-nav ${model.GruposTag.length ? "" : "hide"}`}>*/}
                    {/*            <li className="dropdown categorias">*/}
                    {/*                <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button"*/}
                    {/*                   aria-expanded="false">*/}
                    {/*                    Categorías <i className="pe-va pe-7s-angle-down"></i>*/}
                    {/*                </a>*/}
                    {/*                <ul className="dropdown-menu" role="menu">*/}
                    {/*                    {model.GruposTag.sort((a, b) => a.Nombre.localeCompare(b.Nombre)).map((item) => (*/}
                    {/*                        <li key={item.Id}><Link*/}
                    {/*                            to={`${PRODUCTS_CATEGORIES_PATH}${item.Id}`}>{item.Nombre}</Link></li>*/}
                    {/*                    ))}*/}
                    {/*                </ul>*/}
                    {/*            </li>*/}
                    {/*        </ul>*/}
                    {/*    )}*/}

                    {/* Logo centrado - en la columna del medio */}
                    <div style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        top: "13%",
                        zIndex: 1,
                        gridColumn: "1 / -1",
                        pointerEvents: "none"
                    }}>
                        <Link to={HOME_PATH} style={{
                            display: "block",
                            zIndex: 1,
                            pointerEvents: "auto",
                            textAlign: "center",
                            lineHeight: 0
                        }}>
                            <img src={firstLogoSapore} 
                                 alt="Logo Sapore Di Pane" 
                                 style={{
                                     pointerEvents: "none", 
                                     maxWidth: "138px", 
                                     width: "auto",
                                     height: "auto",
                                     display: "block",
                                     margin: "0 auto"
                                 }}/>
                        </Link>
                    </div>

                    <ul className="nav navbar-nav navbar-right" style={{
                        position: "relative", 
                        zIndex: 2,
                        marginRight: "0",
                        paddingRight: "0",
                        justifySelf: "end",
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "nowrap",
                        gap: "20px",
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        gridColumn: "3",
                        height: "100%"
                    }}>
                        {/*<li><Link to="/Frontend/RepetirPedido"><span className="hidden-xs hidden-sm hidden-md">Repetir Pedido</span>
                                <FontAwesomeIcon icon={faRedo} className="fa-icon" /></Link></li>*/}
                        {selectedCustomer && <CustomerSelector customersOfUser={customers} handleSelect={handleSelect}
                                                               defaultCustomer={selectedCustomer}/>}
                        {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                            userRoles.includes(business.marketplace_operational_role())) && (
                            <li style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                listStyle: "none",
                                margin: 0,
                                padding: 0,
                                height: "100%",
                                position: "relative"
                            }}>
                                <Link to={CART_PATH} style={{
                                    display: "flex", 
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",
                                    padding: 0,
                                    position: "relative"
                                }}>
                                    <span className="material-symbols-outlined"
                                          style={{fontSize: "21px", display: "flex", alignItems: "center"}}>shopping_cart</span>
                                    {model.CantidadArticulos > 0 && (
                                        <span className="checkout-number" style={{
                                            position: "absolute",
                                            right: "-8px",
                                            minWidth: "20px",
                                            height: "20px",
                                            borderRadius: "50%",
                                            backgroundColor: "#bfa889",
                                            color: "#fff",
                                            fontSize: "12px",
                                            fontWeight: "700",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontFamily: "brandon-grotesque, sans-serif",
                                            padding: "0 4px",
                                            lineHeight: "20px"
                                        }}>{model.CantidadArticulos}</span>
                                    )}
                                </Link>
                            </li>
                        )}
                        {showAIButton && <AICartButton userRoles={userRoles} business={business} onPromptClick={handleOpenPromptModal} />}

                        <li style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            listStyle: "none",
                            margin: 0,
                            padding: 0,
                            height: "100%"
                        }}>
                            <a href="#" className="buscar-articulos"
                               onClick={() => setSearchBoxActive(!searchBoxActive)}
                               style={{
                                   display: "flex", 
                                   alignItems: "center",
                                   justifyContent: "center",
                                   height: "100%",
                                   padding: 0
                               }}>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                            fontSize: "21px",
                                            display: "flex",
                                            alignItems: "center"
                                        }}
                                    >
                                        search
                                    </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>

            <nav className="navbar navbar-default navbar-static-top visible-xs">
                <div className="container">
                    <div className="navbar-header">
                        {/*<button type="button" className="navbar-toggle collapsed" data-toggle="collapse"*/}
                        {/*        data-target="#bs-example-navbar-collapse-2">*/}
                        {/*    <span className="sr-only">Toggle navigation</span>*/}
                        {/*    <span className="icon-bar"></span>*/}
                        {/*    <span className="icon-bar"></span>*/}
                        {/*    <span className="icon-bar"></span>*/}
                        {/*</button>*/}
                        {/*<div className="collapse navbar-collapse" id="bs-example-navbar-collapse-2">*/}
                        {/*    <ul className="nav navbar-nav">*/}
                        {/*        <li><Link to={HOME_PATH}><i className="pe-va pe-7s-home"></i> Inicio</Link></li>*/}

                        {/*        {(userRoles.includes(business.marketplace_general_administrator_role()) ||*/}
                        {/*            userRoles.includes(business.marketplace_administrative_role())) && (*/}
                        {/*            <li><Link to={CHECKING_ACCOUNT_PATH}><i className="pe-va pe-7s-cash"></i> Cuenta Corriente</Link></li>*/}
                        {/*        )}*/}

                        {/*        <li><Link to={ORDERS_MANAGEMENT_PATH}><i className="pe-va pe-7s-pen"></i> Solicitudes</Link></li>*/}

                        {/*        /!*<li><Link to={PROFILE_PATH}><i className="pe-va pe-7s-user"></i> Configuración</Link></li>*!/*/}

                        {/*        <li>onClick={handleLogout}><i className="pe-va pe-7s-close-circle"></i> Salir del sistema*/}
                        {/*        </li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}
                        <ul className="list-unstyled navbar-nav">
                            <li className={menuClassName} ref={menuRef}>
                                <Link to={HOME_PATH} style={{marginLeft: "1em"}}
                                      className="navbar-brand dropdown-toggle" data-toggle="dropdown"
                                      role="button" aria-expanded="false" onClick={(e) => onMenuOpen(e)}>
                                  <span>
                                    <span className="icon-bar-nav"></span>
                                    <span className="icon-bar-nav"></span>
                                    <span className="icon-bar-nav"></span>
                                  </span>
                                </Link>
                                <ul className="dropdown-menu" role="menu" style={{marginTop: "3em", marginLeft: "2em"}}>
                                    <li>
                                        <Link to={HOME_PATH} onMouseDown={handleMenuNavigate(HOME_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    home
                                                </span>
                                            Inicio
                                        </Link>
                                    </li>

                                    {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                        userRoles.includes(business.marketplace_operational_role())) && (
                                        <li>
                                            <Link to={CART_PATH} onMouseDown={handleMenuNavigate(CART_PATH)}>
                                                <span
                                                    className="material-symbols-sharp"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 150, 'GRAD' 50, 'opsz' 20",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    shopping_cart
                                                </span>
                                                Mi Carrito
                                            </Link>
                                        </li>
                                    )}

                                    {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                        userRoles.includes(business.marketplace_operational_role())) && (
                                        <li>
                                            <Link to={ORDERS_HISTORY_PATH} onMouseDown={handleMenuNavigate(ORDERS_HISTORY_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    local_mall
                                                </span>
                                                Mis Pedidos
                                            </Link>
                                        </li>
                                    )}

                                    {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                        userRoles.includes(business.marketplace_administrative_role())) && (
                                        <li>
                                            <Link to={CHECKING_ACCOUNT_PATH} onMouseDown={handleMenuNavigate(CHECKING_ACCOUNT_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    payments
                                                </span>
                                                Cuenta Corriente
                                            </Link>
                                        </li>
                                    )}

                                    <li>
                                        <Link to={TICKETS_PATH} onMouseDown={handleMenuNavigate(TICKETS_PATH)}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    ink_pen
                                                </span>
                                            Solicitudes
                                        </Link>
                                    </li>

                                    {/*<li>*/}
                                    {/*    <Link to={PROFILE_PATH}>*/}
                                    {/*        <FontAwesomeIcon icon={faUser} className="fa-icon" /> Configuración*/}
                                    {/*    </Link>*/}
                                    {/*</li>*/}

                                    <li>
                                        <Link to={LOGIN_PATH} onMouseDown={async (event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            await handleLogout();
                                            handleMenuClose();
                                        }}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        color: '#c1a17d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    cancel
                                                </span>
                                            Salir del Sistema
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <div style={{transform: "translateY(80px)"}}>
                            <div style={{transform: "translateX(-45%)"}}>
                                <ul className="nav navbar-nav">
                                    {selectedCustomer &&
                                        <CustomerSelector customersOfUser={customers} handleSelect={handleSelect}
                                                          defaultCustomer={selectedCustomer}/>}
                                </ul>
                            </div>
                        </div>
                        <div style={{transform: "translateY(-135px)"}}>
                            <ul className="nav navbar-nav navbar-right">
                                {/*<li><Link to="/Frontend/RepetirPedido"><span className="hidden-xs hidden-sm hidden-md">Repetir Pedido</span>
                                <FontAwesomeIcon icon={faRedo} className="fa-icon" /></Link></li>*/}
                                {(userRoles.includes(business.marketplace_general_administrator_role()) ||
                                    userRoles.includes(business.marketplace_operational_role())) && (
                                    <li style={{position: "relative", marginRight: "0.1em"}}>
                                        <Link to={CART_PATH}>
                                        <span className="material-symbols-outlined"
                                        >shopping_cart</span>
                                            {model.CantidadArticulos > 0 && (
                                                <span
                                                    className="checkout-number-mobile">{model.CantidadArticulos}</span>
                                            )}
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </div>
                        {/*            <li style={{position: "relative"}}>*/}
                        {/*                <Link to={CART_PATH}>*/}
                        {/*                    <span className="hidden-xs hidden-sm hidden-md">Comprar</span>*/}
                        {/*                    <FontAwesomeIcon icon={faShoppingCart} className="fa-icon"/>*/}
                        {/*                    {model.CantidadArticulos > 0 && (*/}
                        {/*                        <span className="checkout-number">*/}
                        {/*    {model.CantidadArticulos}*/}
                        {/*</span>*/}
                        {/*                    )}*/}
                        {/*                </Link>*/}
                        {/*            </li>*/}
                        {/*<div className="pull-right visible-xs item-nav-xs">*/}
                        {/*    <a className="buscar-articulos" onClick={() => setSearchBoxActive(!searchBoxActive)}>*/}
                        {/*        <i className="pe-7s-search pe-va"></i>*/}
                        {/*    </a>*/}
                        {/*</div>*/}
                    </div>
                    <Link to={HOME_PATH}><img src={secondLogoSapore} className="logo-navbar"
                                              alt="Logo Sapore Di Pane"/></Link>
                </div>
            </nav>


            <div className={`search-box ${searchBoxActive ? 'active' : ''}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <a href="#" className="btn btn-link buscar-articulos"
                               onClick={() => setSearchBoxActive(!searchBoxActive)}>
                                <i className="pe-7s-search"></i>
                            </a>
                            <input
                                id="search-input"
                                type="search"
                                name="search"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                onKeyUp={handleSearch}
                                placeholder="Buscar en Sapore Di Pane"
                                autoFocus
                            />
                            <a type="button" href="#" className="btn btn-primary btn-outlined hidden-xs"
                               onClick={handleSearchButtonClick}>Buscar</a>
                            <a type="button" href="#" className="btn btn-link visible-xs search-xs"><i
                                className="pe-7s-angle-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="landscape-screen">
                <i className="pe-7s-phone"></i>
                <div className="landscape-info">
                    <h3>Para una correcta visualización del contenido rote su teléfono celular en posición vertical</h3>
                </div>
            </div>

            <AICartModals
                promptModalOpen={promptModalOpen}
                setPromptModalOpen={setPromptModalOpen}
                promptText={promptText}
                setPromptText={setPromptText}
                isSubmittingPrompt={isSubmittingPrompt}
                setIsSubmittingPrompt={setIsSubmittingPrompt}
            />
        </>
    );
};

export default observer(Navbar);
